import {getIdFromHash} from '@netx/core-utils';

export const getCategoryIdFromHash = (hash?: string) =>
	getIdFromHash(hash ?? window.location.hash, /#category\/(\d+)/, true);
